// Packages
import React, { useState, useContext, useRef, useEffect } from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import styled, { css } from "styled-components"

// Components
import WhatYouLearn from "@components/knowledge-center/what-you-learn"
import ArticleMarkdown from "@components/knowledge-center/article-markdown"
import ArticleRichText from "@components/knowledge-center/article-richtext"
import ArticleDisclosure from "@components/knowledge-center/article-disclosure"
import NowWhat from "@components/knowledge-center/now-what"
import TeamApplyModal from "@components/global/modal-team-apply"
import ArticleHeader from "./article-header"

// Context
import { WalledContext } from "@components/global/layout"

const size = {
  tablet: 950,
  mobile: 600,
}
const below = Object.keys(size).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${size[label]}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})

const above = Object.keys(size).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (min-width: ${size[label]}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})

const Wrapper = styled.div`
  h1 {
    color: var(--alt-black);
    font-size: 44px;
    line-height: 60px;
    font-family: "Playfair Display", serif;
    font-weight: 400;
    margin-bottom: 48px;
    padding: 0 24px;
    ${above.mobile`
    font-size:56px;
    line-height:72px;
    padding:0 48px;
  `}
    ${above.tablet`
    max-width: 856px;
    padding: 64 48px 16px;
    margin: 0 auto 40px ;
  `}
  }

  .article-disclosure {
    margin-top: 64px;
  }
`
const ArticleContainer = styled.div`
  padding: 48px 24px;

  ${above.mobile`
  padding: 64px 48px;
  `}
  ${above.tablet`
    max-width: 820px;
  margin: 0 auto;
  padding:80px 48px;
  `}
`
const FeatureImage = styled.div`
  max-width: 1296px;
  margin: 0 auto;
  max-height: 630px;
  padding: 0 48px;
  overflow: hidden;
  img {
    max-height: 630px;
  }
  ${below.tablet`
  // max-height: 272px;
  padding:0;
  margin:0 48px;
  `}
  ${below.mobile`
  // max-height: 136px;
  margin: 0 24px;
  `}
`

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background-color: hsla(0, 0%, 0%, 0.8);
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
`

const ArticleContent = ({
  articleData,
  bankerData,
  teamApplyToggle,
  setTeamApplyToggle,
  walledVersion,
}) => {
  const [tooltipOverlay, setTooltipOverlay] = useState(false)
  const articleWrapper = useRef(null)

  return (
    <>
      <ArticleHeader articleData={articleData} bankerData={bankerData} />
      <Wrapper ref={articleWrapper}>
        <h1>{articleData.title}</h1>

        {articleData.whatYouLearn && <WhatYouLearn articleData={articleData} />}

        <FeatureImage>
          <GatsbyImage
            image={
              articleData.featureImage
                ? articleData.featureImage.gatsbyImageData
                : articleData.ogImage.gatsbyImageData
            }
            alt=""
          />
        </FeatureImage>
        <ArticleContainer>
          {!articleData.content && (
            <ArticleMarkdown content={articleData.body.childMarkdownRemark} />
          )}

          {articleData.content && (
            <ArticleRichText
              articleData={articleData}
              bankerData={bankerData}
              richText={articleData.content}
              tooltipOverlay={tooltipOverlay}
              setTooltipOverlay={setTooltipOverlay}
            />
          )}

          {articleData.disclosure && (
            <ArticleDisclosure
              disclosure={articleData.disclosure.childMarkdownRemark.html}
              className="article-disclosure"
            />
          )}
        </ArticleContainer>
        <NowWhat
          CTAs={articleData.nowWhat}
          bankerData={bankerData}
          team={bankerData?.team}
          teamApplyToggle={setTeamApplyToggle}
          walledVersion={walledVersion}
        />
      </Wrapper>
      {teamApplyToggle && (
        <TeamApplyModal
          toggleModal={setTeamApplyToggle}
          team={bankerData?.team}
        />
      )}
      {tooltipOverlay && (
        <ModalOverlay
          onClick={event => {
            event.stopPropagation()
            setTooltipOverlay(false)
          }}
        />
      )}
    </>
  )
}

export default ArticleContent
